import forIn from 'lodash/forIn'
import forEach from 'lodash/forEach'
import find from 'lodash/find'
import { PURPOSE_TAG_CATEGORY } from '@/pages/rules/constants'

const FILTER_NAMES = {
  NAMESPACES: 'namespaces',
  PURPOSE: 'Component Purpose',
  STATE: 'State',
  NEW_COMPONENTS_ONLY: 'New components only'
}

const FILTERS = {
  [FILTER_NAMES.NAMESPACES]: {
    filterFactory: (filterCriteria) => {
      let filters = []
      forIn(filterCriteria, (value, category) => {
        if (value) {
          filters.push((data) => !!find(data.tags, { category, value }))
        }
      })
      return filters
    }
  },
  [FILTER_NAMES.NEW_COMPONENTS_ONLY]: {
    filterFactory: (filterCriteria) => {
      let filters = []
      forEach(filterCriteria, (criteriaValue) => {
        filters.push((data) => data.item.effective_date === criteriaValue)
      })
      return filters
    }
  },
  [FILTER_NAMES.PURPOSE]: {
    filterFactory: (filterCriteria) => {
      let filters = []
      forEach(filterCriteria, (purpose) => {
        if (purpose) {
          filters.push((data) => !!find(data.tags, { category: PURPOSE_TAG_CATEGORY, value: purpose }))
        }
      })
      return filters
    }
  },
  [FILTER_NAMES.STATE]: {
    filterFactory: (filterCriteria) => {
      let filters = []
      if (filterCriteria) {
        filters.push((data) => data.item.state.toLowerCase() === filterCriteria)
      }
      return filters
    }
  }
}

const getNamespacesAvailableFilterCriteria = (namespaces) => {
  let namespacesAvailableFilterCriteria = []
  let filterCriteria
  forIn(namespaces, (value, namespaceName) => {
    if (!filterCriteria) {
      filterCriteria = {
        type: 'form',
        name: FILTER_NAMES.NAMESPACES,
        label: 'Namespaces',
        fields: []
      }
    }
    filterCriteria.fields.push({
      name: namespaceName,
      label: namespaceName,
      type: 'dropdown',
      closeOnChange: true,
      options: value.map(data => {
        return { name: data, label: data }
      })
    })
  })
  if (filterCriteria) {
    namespacesAvailableFilterCriteria.push(filterCriteria)
  }
  return namespacesAvailableFilterCriteria
}

const getNewComponentsOnlyAvailableFilterCriteria = (currentVersion) => {
  return [{
    type: 'select',
    name: FILTER_NAMES.NEW_COMPONENTS_ONLY,
    label: currentVersion.name,
    options: [{ name: currentVersion.effective_date, label: 'New components only' }]
  }]
}

const getPurposeAvailableFilterCriteria = (purposes) => {
  let filterCriteria = {
    type: 'form',
    name: FILTER_NAMES.PURPOSE,
    label: 'Purpose',
    fields: []
  }
  filterCriteria.fields.push({
    name: FILTER_NAMES.PURPOSE,
    label: FILTER_NAMES.PURPOSE,
    type: 'dropdown',
    closeOnChange: true,
    options: purposes.map(purpose => {
      return { name: purpose, label: purpose }
    })
  })
  return filterCriteria.fields ? [filterCriteria] : []
}

const getStateFilterCriteria = () => {
  let filterCriteria = [{
    name: FILTER_NAMES.STATE,
    label: FILTER_NAMES.STATE,
    type: 'radio',
    closeOnChange: true,
    options: [
      { name: 'disabled', label: 'Only disabled' },
      { name: 'enabled', label: 'Only enabled' }
    ]
  }]
  return filterCriteria
}

const componentsFilterFactory = (selectedFilterCriteria) => {
  let filters = []
  forIn(selectedFilterCriteria, (value, key) => {
    filters = [...filters, ...FILTERS[key].filterFactory(value)]
  })
  return filters
}

export {
  FILTER_NAMES,
  getNamespacesAvailableFilterCriteria,
  getNewComponentsOnlyAvailableFilterCriteria,
  getPurposeAvailableFilterCriteria,
  getStateFilterCriteria,
  componentsFilterFactory
}
